const cloneDeep = require("lodash/cloneDeep");

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const tempState = {
  cropper: {},
  recipe: {},
  responses: {
    assets3d: {},
    placements: []
  },
  placementOptions: [],
  cropperOptions: {},
  productImages: {},
  rotated: false,
  placementViewOrder: 0,
  activeUGCComponent: "",
  activeUGCView: "ugc-design-view",
  ugc_image: null,
  ugc_image_id: null,
  ugc_image_format: null,
  ugc_swatch: {},
  ugc_size: null,
  ugcViews: [],
  ugcFlowViews: [],
  ugcFlowComponents: {},
  storeMultipleUGCsizes: false,
  deletePreviousRecipe: null,
  bucketSize: null,
  tempBucketSize: null,
  background_color: null,
  disableBg: false,
  stateManagers: {},
  uploadAnother: null,
  selectAnother: null,
  imageScaleX: null,
  isReplaceTool: false,
  ugcFeature: null,
  replaceComponentFeature: [],
  applyUGCComponents: [],
  hasFinishedApplying: false,
  continueAndEditFlow: false
}

const moduleTempData = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeUGCIndex: 0,
    ugcIndex: [
      "ugc",
      "imageLibrary"
    ],
    features:[]
  }
};

moduleTempData.state.ugcIndex.forEach(() => moduleTempData.state.features.push(cloneDeep(tempState)));
export default moduleTempData;
